import { combineReducers } from 'redux'

import configurator from './configurator';
import { initialState as configuratorInitialState } from './configurator';
import documentStorage from './documentStorage';
import { initialState as documentStorageInitialState } from './documentStorage';
import campaign from './campaign';
import { initialState as campaignInitialState } from './campaign';
import user from './user';
import { initialState as userInitialState } from './user';
import app from './app';
import cart from './cart';
import { initialState as cartInitialState } from './cart';
import imageUpload from './imageUpload';
import { initialState as imageUploadInitialState } from './imageUpload';
import {intlReducer} from 'react-intl-redux';
import * as ActionType from '../constants/ActionType'

const appReducer = combineReducers({
    documentStorage,
    configurator,
    campaign,
    user,
    app,
    cart,
    imageUpload,
    intl: intlReducer
});

const rootReducer = (state, action) => {

    if (action.type === ActionType.LOGOUT_SUCCESS || action.type === ActionType.LOGIN_REQUIRED) {
        // Reset state if Login required (e.g. after session timed out)
        state.campaign = campaignInitialState;
        state.cart = cartInitialState;
        state.configurator = configuratorInitialState;
        state.documentStorage = documentStorageInitialState;
        state.imageUpload = imageUploadInitialState;
        state.user = userInitialState;
    }

    return appReducer(state, action)
};

export default rootReducer


// WEBPACK FOOTER //
// ./src/js/reducers/index.js